module.exports = __webpack_public_path__ + "static/parade-2019-house11-4b6fb8c6c7c11009e9c1e6e030d01c8a.jpg";